import { CommonUtilities } from "../../../commonUtils";
import Pagination from "components/Common/newPagination";
import React, { Suspense, useState, useEffect } from "react";
import ReleaseService from "./ReleaseService";
import EditRelease from "./EditRelease";
import AssetLinkingServices from "../../AssetLinking/AssetLinkingServices";
import ViewContractAsset from "../../Common/ViewContractAsset"; 

export default function ReleaseListing(projectDetails: any) {

    const [totalRows, setTotalRows] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1";
    const [releaseslist, initReleaseslist] = useState<any[]>([]);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        ProjectId: projectDetails.projectDetails.ProjectId,
        assetType: 'release'
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        getRelease()
    }

    const UnlinkRelease = (value: any) => {
        var dataLink = "";
        dataLink = value.projectAssetId;
        AssetLinkingServices.unlinkAsset(dataLink)
    }

    const getRelease = () => {
        dataLink = 'projectId=' + Data.ProjectId + '&assetType=' + Data.assetType + '&pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        Data.ProjectId = projectDetails.projectDetails.ProjectId;
        ReleaseService.ReleaseListing(dataLink)
        .then((res) => {
            console.log(res.length);
            if(res.length === 0){
                projectDetails.onChange(0)
                setTotalRows(0);
            }else{
                initReleaseslist(res)
                setTotalRows(res[0].totalRows);
                projectDetails.onChange(totalRows)
            }

        })
    }

    const handleRefresh = () => {
        getRelease();
      };

    useEffect(() => {
       getRelease()
    }, [totalRows]);


    return (

            <div className="box-content p0">
                <Suspense fallback={<div>Loading</div>}>
                    <div className="allowHscroll">
                        {

                        (() => {
                            if (totalRows > 1 && totalRows > 0) {
                                return (
                                    <table>
                                    <thead>
                                        <tr className="forceSingleLine">
                                            <th>Release Codes</th>
                                            <th>Release Title</th>
                                            <th>Release Artist Name</th>
                                            <th>Release Barcode</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            releaseslist.map(post => (
                                                <tr>
                                                    <td >{post.code}
                                                    {<ViewContractAsset data={post} type="release" projectId={Data.ProjectId}/>} 
                                                        
                                                    </td>
            
                                                    <td>{post.name}</td>
                                                    <td>{post.releaseArtistName}</td>
                                                    <td>{post.releaseBarcode}</td>
                                                    <td className="ws-12 forceSingleLine">
                                                        <EditRelease releaseDetails={post} />
            
                                                        <button className="icon-btn delete btn-xs" onClick={()=> {UnlinkRelease(post); handleRefresh()}}>
                                                            <i className="icon-trashcan"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
            
                                    </tbody>
                                </table>
                                )
                            }else {
                                return (<div className="ptl">
                                    <span className="alert alert-success ws-12 text-center">No data Available</span>
                                </div>)
                            }

                        })()

                        }
                    </div>

                    <div className="ws-12">
                        {

                            (() => {
                                if (totalRows > 1 && totalRows > 10) {
                                    return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                                }

                            })()

                        }
                    </div>
                </Suspense>
            </div>

    )
}